export default "/images/vendor/flag-icon-css/flags/4x3/ic.svg?500d420982feb8a67cbcdd485d62f965";